module.exports = __webpack_public_path__ + "99daeabf1b4c90566e62a411da7aadc8.svg";